/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_AdminInputs */

const en_admin_tickets_admin = /** @type {(inputs: Admin_Tickets_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const zh_admin_tickets_admin = /** @type {(inputs: Admin_Tickets_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Admin_Tickets_AdminInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_admin = /** @type {((inputs?: Admin_Tickets_AdminInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_AdminInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_admin(inputs)
	return zh_admin_tickets_admin(inputs)
});
export { admin_tickets_admin as "admin.tickets.admin" }